module.exports = __webpack_public_path__ + "sketch_border-0f477790b9832d057175f99df9758452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/sketch_border.png
// module id = 1586
// module chunks = 1